import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationHelper } from '../../helpers/notification.helper';
import { LayoutService } from '../../services/layout.service';
import { WorkflowTraceService } from '../../services/workflowtrace.service';

/**
 * Zeigt die Ablaufprotokolle der Workflow-Laeufe und pflegt deren Grenzen.
 *
 * Die Grenzen stehen bewusst auf derselben Seite: Wer die Laeufe ansieht, entscheidet auch,
 * wie viele aufgehoben werden.
 */
@Component({
    selector: 'workflowtrace-settings',
    templateUrl: './workflowtrace.settings.html',
    styleUrls: ['./workflowtrace.settings.css']
})
export class WorkflowTraceSettings implements OnInit, OnDestroy {

    Runs = [];
    Lines = [];
    SelectedRun = null;
    Settings = { MaxErrorRuns: 100, MaxRuns: 200, MaxLinesPerRun: 20000, HeartbeatSeconds: 30 };
    ShowSettings = false;
    OnlyErrors = false;
    private reload;

    static GetSettingsEntry() {
        return {
            Caption: '@@WorkflowTrace',
            ID: 'workflowtrace',
            Icon: 'workflow',
            Index: 61,
            Parent: 'settings',
            Security: {
                Name: 'evidanza.App.Shared.Workflow.Rest.WorkflowRight',
                Value: 8
            },
            Content: WorkflowTraceSettings
        };
    }

    constructor(private cdRef: ChangeDetectorRef, private service: WorkflowTraceService) {
    }

    ngOnInit(): void {
        this.RefreshRuns();
        this.service.GetSettings().subscribe(x => {
            if (x) {
                this.Settings = x;
                this.cdRef.detectChanges();
            }
        });
    }

    ngOnDestroy(): void {
        this.StopReload();
    }

    get VisibleRuns() {
        return this.OnlyErrors ? this.Runs.filter(x => x.State !== 'Success') : this.Runs;
    }

    RefreshRuns() {
        LayoutService.Loading.next(true);
        this.service.GetRuns().subscribe(x => {
            LayoutService.Loading.next(false);
            this.Runs = (x || []).map(run => {
                run.Duration = run.Finished && run.Started
                    ? Math.round((new Date(run.Finished).getTime() - new Date(run.Started).getTime()) / 1000) + ' s'
                    : '';
                return run;
            });
            this.cdRef.detectChanges();
        }, () => LayoutService.Loading.next(false));
    }

    SelectRun(run) {
        this.StopReload();
        this.SelectedRun = run;
        this.Lines = [];
        this.LoadLines();
        // Ein Lauf ohne Ende laeuft noch -- oder haengt. Genau dafuer ist das Protokoll da,
        // also nachladen, solange er offen ist.
        if (run && run.State === 'Running') {
            this.reload = setInterval(() => this.LoadLines(), 3000);
        }
    }

    private LoadLines() {
        if (!this.SelectedRun) {
            return;
        }
        const from = this.Lines.length > 0 ? this.Lines[this.Lines.length - 1].Index : 0;
        this.service.GetLines(this.SelectedRun.RunID, from).subscribe(x => {
            if (x && x.length > 0) {
                this.Lines = this.Lines.concat(x);
                this.cdRef.detectChanges();
            }
        });
    }

    private StopReload() {
        if (this.reload) {
            clearInterval(this.reload);
            this.reload = null;
        }
    }

    SaveSettings() {
        this.service.SaveSettings(this.Settings).subscribe(x => {
            if (x) {
                this.Settings = x;
            }
            NotificationHelper.Success('@@Einstellungen gespeichert', '@@WorkflowTrace');
            this.cdRef.detectChanges();
        });
    }

    /** Fuer den Support: der Ablauf als Text, so wie er auf dem Bildschirm steht. */
    Export() {
        const text = this.Lines.map(x => `${x.Timestamp} [${x.Type}] ${x.Text}`).join('\n');
        const blob = new Blob([text], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'trace_' + (this.SelectedRun ? this.SelectedRun.RunID : 'run') + '.txt';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 10000);
    }
}
